import translations from "../constants/translations.json"
//  * Function retourne le texte dependant du props.match.params.language


export default function Translator(language, page) {
    return translations[language || "fr"][page];
}